module.exports = __webpack_public_path__ + "static/media/buy_pause_payment_2.b8ff3df1.jpg";